<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
        <div class="w-full h-full">
            <div class="w-full flex flex-col justify-center items-start mb-5 gap-1">
                <p class="text-gray-400 text-sm"><span @click="$router.push('/services')"
                        class="hover:underline cursor-pointer">Services</span> / Electronic Fund Transfer</p>
                <h1 class="text-theme-primary text-3xl font-semibold">Electronic Fund Transfer</h1>
            </div>


            <div class="rounded w-full bg-white p-5">
                <p v-if="has_read_tnc && $store.state.banks && !show_loader"
                    class="px-3 text-gray-600 font-medium text-lg border-l-8 border-theme-secondary mb-5">Registered
                    Bank Accounts</p>
                <SkeletonControl v-show="show_loader" class="mt-5" />
                <div v-show="!show_loader && eft_close && (($store.state.banks && !has_read_tnc) || !$store.state.banks)"
                    class="font-medium space-y-3 text-xs lg:text-sm leading-5 text-justify rounded w-full bg-blue-100 border-l-8 border-theme-info-default text-blue-900 p-5">
                    <p>Thank you for your interest in applying for the EFT for your Patronage Refund and
                        Interest in Share Capital (Dividend).</p>
                    <p>Please be informed that the application is temporarily <b>CLOSED.</b> Rest assured, the
                        application will reopen for the distribution of Dividend and Patronage Refund next year.</p>
                    <p>Kindly wait for further announcements here in the membership portal and through our
                        official channels.</p>
                    <p>We appreciate your patience and understanding.</p>
                </div>
                <div v-show="!show_loader">
                    <!--Has No Bank-->
                    <div v-if="!$store.state.banks && has_read_tnc && !eft_close"
                        class="border-gray-200 border-2 rounded-lg flex flex-col items-center justify-center p-5">
                        <img src="@/assets/images/papsi_empty.png" class="w-16 opacity-75 mb-2">
                        <p class="font-medium text-gray-600 text-lg px-0 sm:px-8 md:px-16 lg:px-32">No bank account is
                            enrolled under your PAFCPIC Account.</p>
                        <p class="text-sm lg:text-base text-gray-500 px-0 sm:px-8 md:px-16 lg:px-32 mt-2">Right now,
                            only PNB accounts opened
                            through PSOs are supported. For members who opened their PNB accounts through other
                            channels,
                            please stay tuned—your accounts will be included in the next phase of our system
                            integration. If you
                            haven’t opened your PNB account yet, please visit your nearest PSO to apply while cards are
                            still free.</p>
                    </div>
                    <!--Has Bank-->
                    <div v-if="(has_read_tnc || eft_close) && $store.state.banks && has_read_tnc"
                        class="border-gray-200 border-2 rounded-lg flex flex-col p-5">
                        <div class="flex flex-row items-center justify-between">
                            <div class="flex flex-row space-x-3 items-center ">
                                <img src="https://resource.pafcpic.net/assets/logo/pnb_papsi.png" class="w-8">
                                <div class="text-gray-600">
                                    <p class="font-medium text-sm lg:text-lg">{{ $store.state.banks.bank_name }}</p>
                                    <div class="flex flex-row items-center space-x-2">
                                        <p class="text-xs lg:text-base">{{ maskedBankNo }}</p>
                                        <img @click="toggleBank"
                                            :src="visible_bank ? require('@/assets/images/papsi_vis_icon.svg') : require('@/assets/images/papsi_invi_icon.svg')"
                                            class="w-5 h-5 cursor-pointer">
                                    </div>

                                </div>
                            </div>

                            <!-- <button class="rounded-full p-1 hover:bg-gray-300"
                                @click="dropdown_collapse = !dropdown_collapse">
                                <img src="@/assets/images/papsi_down.svg">
                            </button> -->
                        </div>

                        <transition name="dropdown">
                            <div v-if="dropdown_collapse" class="w-full mt-4 flex flex-col space-y-4">
                                <div v-for="sub in subscriptions" :key="sub.subscription_key"
                                    class="flex flex-col lg:flex-row justify-between items-start lg:items-center rounded-xl bg-gray-100 p-3 lg:p-5">
                                    <div class="flex flex-col">
                                        <p class="font-medium">{{ sub.subscription_name.replace('EFT - ', '') }}</p>
                                        <p class="text-xs lg:text-sm text-gray-500">Receive your {{
                                            sub.subscription_name.replace('EFT - ', '') }} via EFT</p>
                                    </div>
                                    <ToggleControl :model-value="sub.subscription_status"
                                        @update:modelValue="onToggle(sub, $event)" class="mt-2 lg:mt-0"
                                        :class="[eft_close ? 'opacity-25 cursor-not-allowed' : '']" />
                                </div>

                                <div v-show="!eft_close"
                                    class="w-full text-right mt-5 flex flex-col lg:flex-row justify-end space-x-0 lg:space-x-3 items-center">
                                    <Button :button_text="toggleAllLabel" is_secondary @clicked="toggleAll"
                                        class="w-full lg:w-1/4" />
                                    <Button :button_text="'Save Changes'" :theme="'text-white'" :disabled="!save_btn"
                                        @clicked="saveSubscriptions" class="w-full lg:w-1/4 mt-4 lg:mt-0" />
                                </div>
                            </div>
                        </transition>

                    </div>
                    <div v-if="!has_read_tnc && !eft_close"
                        class="w-full flex flex-col text-xl justify-start text-left items-start space-y-6">
                        <EFTTermsView />
                        <div class="w-full flex justify-end space-x-3 mt-6">
                            <Button :button_text="'I Agree'" :theme="'bg-theme-primary text-white'"
                                @clicked="closeTerms" />
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <ModalControl v-show="show_pin_modal" v-bind:display="show_pin_modal" z_value="z-40" closable
            @closed="show_pin_modal = false; show_subscribe_modal = true;" id='pin_modal' :default_width="'max-w-lg'">
            <div class="pt-6">
                <h2 class="text-2xl lg:text-3xl font-bold text-theme-primary mb-2 text-left">PIN Verification</h2>
                <p class="mb-5 text-left text-base">Please enter your Personal Identification Number (PIN) to proceed.
                </p>

                <div class="w-full flex flex-row justify-center my-4">
                    <v-otp-input :is-disabled="false" ref="pinOTP" input-classes="otp-input" :input-type="pin_type"
                        inputmode="numeric" :num-inputs="6" v-model:value="pin_value" :should-auto-focus="true"
                        :should-focus-order="true" :key="otpInputKey" @on-complete="validatePIN"
                        @on-change="changePIN" />
                    <div class="otp-input flex justify-center items-center text-center bg-gray-100 cursor-pointer"
                        @click="togglePeeker()">
                        <Icon :source="getImgSrc()" :width="24" />
                    </div>
                </div>

                <div v-if="pin_error_message" class="w-full flex items-center justify-center text-center mt-3">
                    <div class="text-red-500 text-center bg-red-100 px-4 py-2 rounded-full font-medium text-base"
                        v-text="pin_error_message" />
                </div>
            </div>
        </ModalControl>

        <ModalControl v-show="showCloseModal && $store.state.banks && has_read_tnc && !show_loader && eft_close"
            v-bind:display="showCloseModal && $store.state.banks && has_read_tnc && !show_loader" :note="true"
            :question="this.question" z_value="z-50" @positiveClick="closeEFTModal" :positiveButton="'OK'"
            :default_width="'max-w-xl'" id='vote_modal'>
            <div
                class="w-full px-5 pt-2 pb-4 flex flex-col justify-center text-center items-center text-base lg:text-lg space-y-3">
                <p>
                    Submission of applications for EFT for the Patronage Refund and Interest on Share Capital (Dividend)
                    has
                    officially <span class="font-bold text-blue">CLOSED.</span> </p>

                <p>If you wish to make changes, you may
                    do so once the application reopens, but these will only take effect
                    in next year’s distribution.</p>
                <p>Thank you for your understanding and cooperation.</p>

            </div>
        </ModalControl>

        <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
            :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
            @positiveClick="handlePositiveClick()" :positiveButton="'OK'" :default_width="'max-w-xl'" id='vote_modal'>
            <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
                {{ this.modal_message }}
            </div>
        </ModalControl>

        <ModalControl v-show="terms_modal" v-bind:display="terms_modal" z_value="z-50" closable
            @closed="terms_modal = false" :default_width="'max-w-4xl'" id='eft_modal'>
            <div class="w-full pt-6 flex flex-col text-xl justify-start text-left items-start space-y-6">
                <EFTTermsView />

                <div class="w-full flex justify-end space-x-3 mt-6">
                    <Button :button_text="'Cancel'" is_secondary
                        @clicked="terms_modal = false; pendingSubscription = null;" />
                    <Button :button_text="'Agree'" :theme="'bg-theme-primary text-white'" @clicked="agreeToTerms" />
                </div>
            </div>
        </ModalControl>





    </div>
</template>

<script>
import { defineComponent } from 'vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import EFTTermsView from '../static/EFTTermsView.vue';
import SkeletonControl from '@/components/controls/SkeletonControl.vue';
// import Checkbox from "@/components/controls/CheckBox.vue";
// import PictureBoxControl from '@/components/controls/PictureBoxControl.vue';
import Button from '@/components/controls/ButtonControl.vue';
import ToggleControl from '@/components/controls/ToggleControl.vue';
import Icon from "@/components/controls/Icon.vue";
import VOtpInput from "vue3-otp-input";
import User from "@/services/User";
import mixin from '@/mixin';

export default defineComponent({
    components: {
        ModalControl,
        // PictureBoxControl,
        ToggleControl,
        // Checkbox,
        SkeletonControl,
        Button,
        Icon,
        VOtpInput,
        EFTTermsView
    },
    mixins: [mixin],
    inject: ['setLoading'],
    data() {
        return {
            showCloseModal: true,
            eft_close: true,
            has_read_tnc: true,
            terms_shown_on_load: false,
            show_loader: false,
            visible_bank: false,
            dropdown_collapse: true,
            terms_modal: false,
            // show_subscribe_modal: false,
            show_pin_modal: false,
            pin_type: 'password',
            visible_pin: false,
            pin_error_message: '',
            show_message_modal: false,
            modal_message: '',
            success: false,
            warning: false,
            error: false,
            question: false,
            pin_value: '',
            otpInputKey: 0,
            expired: false,
            activeTab: 'form',
            selected: {
                patref: false,
                dividend: false,
                loan: false
            },
            status: null,
            subscriptions: [],
            pendingSubscriptions: [],
        }
    },
    mounted() {
        const state = this.$store.state;

        if (!state.credentials.username) {
            this.getUserInfo();
        } else {
            this.checkUserFlow();
        }
    },
    computed: {
        maskedBankNo() {
            const bankNo = this.$store.state.banks.bank_act_no;
            if (!bankNo) return '';
            return this.visible_bank ? bankNo : this.maskBankNo(bankNo);
        },
        save_btn() {
            return this.subscriptions.some(sub => sub.is_changed);
        },
        allOriginallyOn() {
            // Returns true if all subscriptions were ON originally
            return this.subscriptions.length > 0 &&
                this.subscriptions.every(sub => sub.original_status === 1);
        },
        toggleAllLabel() {
            // If all are currently ON → show "Unsubscribe to All"
            // Otherwise → show "Subscribe to All"
            if (this.subscriptions.length === 0) return "Subscribe to All";
            const allOn = this.subscriptions.every(sub => sub.subscription_status === 1);
            return allOn ? "Unsubscribe to All" : "Subscribe to All";
        },
    },
    methods: {
        closeEFTModal() {
            this.showCloseModal = false;
        },
        closeTerms() {
            this.has_read_tnc = true;
            this.dropdown_collapse = true;
        },
        toggleAll() {
            // Determine if we are turning all ON or OFF
            const allOn = this.subscriptions.every(sub => sub.subscription_status === 1);
            const newStatus = allOn ? 0 : 1;

            // Toggle all subscriptions
            this.subscriptions.forEach(sub => {
                sub.subscription_status = newStatus;
                sub.is_changed = sub.subscription_status !== sub.original_status;
            });
        },
        onToggle(sub, newValue) {
            if (this.eft_close) {
                return;
            }
            sub.subscription_status = newValue ? 1 : 0;
            sub.is_changed = sub.subscription_status !== sub.original_status;
        },
        agreeToTerms() {
            this.terms_modal = false;

            // Case 1: when user toggled a single subscription ON
            if (this.pendingSubscription) {
                this.show_pin_modal = true;
                this.pin_value = '';
                this.pin_error_message = '';
                this.pendingSubscription = null;
                return;
            }

            // Case 2: when "Save Changes" was clicked (batch update)
            if (this.pendingChanges && this.pendingChanges.length > 0) {
                this.show_pin_modal = true;
                this.pin_value = '';
                this.pin_error_message = '';
            }
        },
        subscribe(sub) {
            if (!sub.subscription_status) {
                // User toggled from OFF → ON
                this.pendingSubscription = sub;
                this.terms_modal = true; // show Terms first
            } else {
                // User toggled from ON → OFF
                sub.subscription_status = false;
            }
        },
        saveSubscriptions() {
            const changedSubs = this.subscriptions.filter(sub => sub.is_changed);

            if (changedSubs.length === 0) {
                this.modal_message = "No changes to update.";
                this.success = false;
                this.warning = true;
                this.error = false;
                this.show_message_modal = true;
                return;
            }

            const hasOffToOn = changedSubs.some(
                sub => sub.original_status === 0 && sub.subscription_status === 1
            );

            this.pendingChanges = changedSubs.map(sub => ({
                subscription_key: sub.subscription_key,
                subscription_status: sub.subscription_status ? 1 : 0,
            }));

            // 🔁 Reversed logic here
            if (hasOffToOn) {
                if (this.$store.state.banks.has_read_tnc) {
                    // ✅ If already read T&C → show Terms first
                    this.terms_modal = true;
                } else {
                    // ✅ If NOT yet read T&C → skip Terms and go straight to PIN modal
                    this.show_pin_modal = true;
                    this.pin_value = '';
                }
            } else {
                // For OFF → OFF or ON → OFF changes, always show PIN modal
                this.show_pin_modal = true;
                this.pin_value = '';
            }
        },

        toggleBank() {
            this.visible_bank = !this.visible_bank;
        },
        getToggleIcon() {
            return this.visible_bank
                ? require('@/assets/images/papsi_vis_icon.svg')
                : require('@/assets/images/papsi_invi_icon.svg');
        },
        maskBankNo(bankNo) {
            if (!bankNo) return '';
            // Show only last 4 digits, replace the rest with asterisks
            const visiblePart = bankNo.slice(-4);
            const maskedPart = '*'.repeat(bankNo.length - 4);
            return maskedPart + visiblePart;
        },
        getBanks() {
            this.show_loader = true;
            User.getBanks()
                .then((response) => {
                    this.show_loader = false;
                    const state = this.$store.state;

                    state.banks = response.data.data;
                    this.subscriptions = response.data.data?.member_subcription || [];

                    // ✅ Only true if API explicitly says so
                    this.has_read_tnc = response.data.data?.has_read_tnc === true;

                    // Initialize subscription flags
                    this.subscriptions.forEach(sub => {
                        sub.subscription_status = Number(sub.subscription_status);
                        sub.original_status = sub.subscription_status;
                        sub.is_changed = false;
                    });

                    // ✅ If T&C not yet read, show it
                    if (!this.has_read_tnc) {
                        this.terms_shown_on_load = true;
                    }
                })
                .catch((error) => {
                    this.show_loader = false;
                    this.show_message_modal = true;
                    this.modal_message = error.response.data.message;
                    this.error = true;
                    if (error.response && error.response.status == 403) {
                        this.expired = true;
                        this.modal_message = "Your session has expired. Please log in again.";
                        this.$store.state.logged = false;
                    }
                });
        },
        closed() {
            let that = this;

            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },
        subscribeBank() {
            // Collect only the subscriptions that have changed
            const changedSubscriptions = this.subscriptions
                .filter(sub => sub.is_changed)
                .map(sub => sub.subscription_key);

            if (changedSubscriptions.length === 0) {
                this.modal_message = "No changes to update.";
                this.success = false;
                this.warning = true;
                this.error = false;
                this.show_message_modal = true;
                return;
            }

            const payload = {
                bank_key: this.$store.state.banks.bank_key,
                subscription_key: changedSubscriptions,
            };
            const state = this.$store.state.banks;

            this.setLoading(true);
            User.subscribeEFT(payload, state.bank_acct_c, state.bank_acct_s)
                .then(() => {
                    this.setLoading(false);
                    this.error = false;
                    this.warning = false;
                    this.success = true;
                    this.show_message_modal = true;
                    this.show_pin_modal = false;
                    this.modal_message =
                        "Your EFT subscription updates have been successfully saved!";
                    this.subscriptions.forEach(sub => {
                        sub.original_status = sub.subscription_status;
                        sub.is_changed = false;
                    });
                })
                .catch((error) => {
                    let that = this;
                    that.error = true;
                    that.setLoading(false);
                    that.show_message_modal = true;
                    that.modal_message = error.response.data.message;
                    if (error.response.status == 403) {
                        that.expired = true;
                        that.modal_message = "Your session has expired. Please log in again.";
                        that.$store.state.logged = false;
                    }
                });
        },
        agree({ id, value }) {
            console.log(`${id} selected:`, value);
        },
        getImgSrc() {
            return this.visible_pin ? "images/papsi_vis_icon.svg" : "images/papsi_invi_icon.svg";
        },
        togglePeeker() {
            if (this.pin_type == 'password') {
                this.visible_pin = true;
                this.pin_type = 'number';
            } else {
                this.visible_pin = false;
                this.pin_type = 'password';
            }
        },
        changePIN() {
            this.pin_error_message = '';
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.show_message_modal = false;
                this.show_pin_modal = false;
                this.pin_value = '';
            }
        },
        validatePIN() {
            let that = this;

            const cookie = that.$cookies;
            let pin_payload = {
                hash: cookie.get('user_session').hash,
                pin: that.pin_value
            }

            that.setLoading(true);
            that.show_message_modal = false;
            that.show_pin_modal = false;
            User.validateOldPin(cookie.get('user').uuid, pin_payload).then(function () {
                // that.setLoading(false);
                // that.error = false;
                // that.info = false;
                // that.warning = false;
                // that.success = true;
                // that.show_message_modal = true;
                // that.show_pin_modal = false;
                // that.modal_message = "You have successfully subscribed your account to Electronic Fund Transfer. Thank you!";

                that.subscribeBank();

            }).catch(function (error) {
                if (error.response.status === 403) {
                    that.expired = true;
                    that.$store.state.logged = false;
                    that.setLoading(false);
                    that.error = true;
                    that.info = false;
                    that.warning = false;
                    that.success = false;
                    that.show_message_modal = true;
                    that.modal_message = "Your session has expired. Please log in again.";
                }
                that.setLoading(false);
                that.pin_error_message = error.response.data.message;
                that.otpInputKey++;
                that.show_pin_modal = true;
                that.pin_value = '';
            });
        },
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            this.getBanks();

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
    },
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
